import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams, useHistory, useLocation } from 'react-router-dom'
import { getPackagesFxn } from './actions'
import { Row, Col, Card, Typography, Button, Divider, Tag, Badge, Breadcrumb, Rate, Icon } from 'antd'
import PlanDetailsModal from './planDetailsModal'
import './esim.css'
import { showPageLoad, hidePageLoad } from '../../modules/actions'

const { Title, Text } = Typography

const useQuery = () => {
  return new URLSearchParams(useLocation().search)
}

const EsimPackageDetails = () => {
  const { countryId } = useParams()
  const query = useQuery()
  const routeType = query.get('type') || 'local'

  const dispatch = useDispatch()
  const history = useHistory()
  const [packageList, setPackageList] = useState([])
  const [activePackageType, setActivePackageType] = useState(routeType === 'local' ? 1 : 2)
  const [quantities, setQuantities] = useState({})
  const [selectedPackage, setSelectedPackage] = useState(null)
  const [showPlanDetails, setShowPlanDetails] = useState({
    visible: false,
    packageData: {}
  })

  // const token = useSelector((state) => {
  //     const esimToken = state.esimReducer && state.esimReducer.token;
  //     return esimToken && esimToken.token ? esimToken.token : "";
  // });

  const {
    destinationsType1,
    destinationsType2,
    destinationsType3,
    packageType1,
    packageType2,
    packageType3
  } = useSelector(state => ({
    destinationsType1: state.esimReducer.destinationsType1 || [],
    destinationsType2: state.esimReducer.destinationsType2 || [],
    destinationsType3: state.esimReducer.destinationsType3 || [],
    packageType1: state.esimReducer.packageType1 || [],
    packageType2: state.esimReducer.packageType2 || [],
    packageType3: state.esimReducer.packageType3 || []
  }))

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  const getCountryDetails = () => {
    let countryDetails = {
      name: countryId.toUpperCase(),
      country_id: countryId
    }

    if (routeType === 'local') {

      const foundCountry = destinationsType1.find(country => country.country_id === countryId)
      if (foundCountry) {
        countryDetails = foundCountry
      }
    } else if (routeType === 'region') {

      const foundRegion = destinationsType2.find(region => region.country_id === countryId)
      if (foundRegion) {
        countryDetails = foundRegion
      }
    }

    return countryDetails
  }

  const countryDetails = getCountryDetails()
  useEffect(() => {
    const fetchPackagesBasedOnType = async () => {
      if (!countryId) return

      try {
        if (routeType === 'local') {
          const isInType1 = destinationsType1.length > 0 &&
            destinationsType1.some(country => country.country_id === countryId)

          // Check current packageType1 state directly instead of relying on dependency
          if (isInType1 && packageType1.length === 0) {
            dispatch(showPageLoad())
            const res1 = await dispatch(getPackagesFxn({ country_id: countryId }))
            dispatch(hidePageLoad())
            if (res1 && res1.success && res1.data && res1.data.data) {
              dispatch({ type: 'SET_PACKAGES_TYPE_1', payload: res1.data.data })
            }
          }

          let regionCountryId = null
          if (destinationsType2.length > 0) {
            for (let region of destinationsType2) {
              if (region.countries && region.countries.length > 0) {
                const foundInRegion = region.countries.some(country => country.country_id === countryId)
                if (foundInRegion) {
                  regionCountryId = region.country_id
                  break
                }
              }
            }
          }

          // Check current packageType2 state directly
          if (regionCountryId && packageType2.length === 0) {
            const res2 = await dispatch(getPackagesFxn({ country_id: regionCountryId }))
            if (res2 && res2.success && res2.data && res2.data.data) {
              dispatch({ type: 'SET_PACKAGES_TYPE_2', payload: res2.data.data })
            }
          }

        } else if (routeType === 'region') {
          // Check current packageType2 state directly
          if (packageType2.length === 0) {
            dispatch(showPageLoad())
            const res2 = await dispatch(getPackagesFxn({ country_id: countryId }))
            dispatch(hidePageLoad())
            if (res2 && res2.success && res2.data && res2.data.data) {
              dispatch({ type: 'SET_PACKAGES_TYPE_2', payload: res2.data.data })
            }
          }
        }

        // Check current packageType3 state directly
        if (packageType3.length === 0) {
          const res3 = await dispatch(getPackagesFxn({ country_id: 'global' }))
          if (res3 && res3.success && res3.data && res3.data.data) {
            dispatch({ type: 'SET_PACKAGES_TYPE_3', payload: res3.data.data })
          }
        }

      } catch (error) {
        console.error('Error fetching packages:', error)
      }
    }

    fetchPackagesBasedOnType()
  }, [routeType, countryId, dispatch, destinationsType1, destinationsType2])

  useEffect(() => {
    let currentPackages = []

    switch (activePackageType) {
      case 1:
        currentPackages = routeType === 'local' ? (packageType1 || []) : []
        break
      case 2:
        currentPackages = packageType2 || []
        break
      case 3:
        currentPackages = packageType3 || []
        break
      default:
        currentPackages = []
    }

    setPackageList(currentPackages)
    if (currentPackages && currentPackages.length > 0) {
      const initialQuantities = {}
      currentPackages.forEach(pkg => {
        if (pkg && pkg.id) {
          initialQuantities[pkg.id] = 1
        }
      })
      setQuantities(prev => ({ ...prev, ...initialQuantities }))
    }
  }, [activePackageType, packageType1, packageType2, packageType3, routeType])

  const updateQuantity = (packageId, change) => {
    setQuantities(prev => ({
      ...prev,
      [packageId]: Math.max(1, (prev[packageId] || 1) + change)
    }))
  }

  const handleBuyNow = () => {
    if (selectedPackage && selectedPackage.package_id) {
      history.push('/esim-checkout', {
        selectedPackage: selectedPackage,
        countryDetails: countryDetails,
        quantity: 1,
        activePackageType: activePackageType,
        routeType: routeType
      })
    }
  }

  const handlePackageTypeChange = (type) => {
    setActivePackageType(type)
    setSelectedPackage(null)
  }

  const handlePackageDetailsClick = (e, pkg) => {
    e.stopPropagation()
    setShowPlanDetails({
      visible: true,
      packageData: pkg
    })
  }

  const handleModalClose = () => {
    setShowPlanDetails({
      visible: false,
      packageData: {}
    })
  }

  const handleModalSubmit = () => {
    if (showPlanDetails.packageData && showPlanDetails.packageData.package_id) {
      handleModalClose()
      history.push('/esim-checkout', {
        selectedPackage: showPlanDetails.packageData,
        countryDetails: countryDetails,
        quantity: 1,
        activePackageType: activePackageType,
        routeType: routeType
      })
    }
  }
  return (
    <div className='esim-package-container'>
      <div className='esim-package-wrapper'>
        {/* Breadcrumb */}
        <Card className='esim-breadcrumb-card'>
          <Breadcrumb>
            <Breadcrumb.Item>
              <Button
                type='link'
                onClick={() => history.push('/apply-for-esim')}
                className='esim-breadcrumb-back-btn'
              >
                {routeType === 'region' ? 'Regions' : 'Destinations'}
              </Button>
            </Breadcrumb.Item>
            <Breadcrumb.Item>{countryDetails.name}</Breadcrumb.Item>
            <Breadcrumb.Item>
              <Tag color={routeType === 'local' ? 'blue' : 'green'}>
                {routeType === 'local' ? 'Local' : 'Regional'}
              </Tag>
            </Breadcrumb.Item>
          </Breadcrumb>
        </Card>

        {/* Main Content */}
        <Card className='esim-main-card'>
          <Row gutter={[48, 48]} align='middle'>
            {/* Left Side - Circular Image */}
            <Col xs={24} lg={10}>
              <div className='esim-image-section'>
                <div className='esim-circular-image-container'>
                  <img
                    src={`https://www.amigosim.com/assets/DestinationListingImages/${countryId}.webp`}
                    alt={countryDetails.name}
                    className='esim-circular-image'
                    onError={(e) => {
                      // Fallback for missing images
                      e.target.style.display = 'none'
                      e.target.parentElement.innerHTML = `
                                                <div style='
                                                    width: 100%; 
                                                    height: 100%; 
                                                    background: linear-gradient(135deg, #1556BC, #667eea); 
                                                    display: flex; 
                                                    align-items: center; 
                                                    justify-content: center; 
                                                    color: white; 
                                                    font-size: 48px; 
                                                    font-weight: bold;
                                                    border-radius: 50%;
                                                '>
                                                    ${countryDetails.name.charAt(0)}
                                                </div>
                                            `
                    }}
                  />
                </div>
              </div>
            </Col>

            {/* Right Side - Content */}
            <Col xs={24} lg={14}>
              <div className='esim-content-section'>
                <Title level={1} className='esim-main-title'>
                  eSIM for {
                  activePackageType === 3
                    ? 'World'
                    : countryDetails.name
                }
                </Title>

                {/* Rating Section */}
                <div className='esim-rating-section'>
                  <div className='esim-rating-container'>
                    <Rate
                      disabled
                      defaultValue={5}
                      className='esim-rating-stars'
                    />
                    <Text strong className='esim-rating-score'>4.6/5</Text>
                    <Text className='esim-trustpilot-badge'>★ Trustpilot</Text>
                  </div>
                  <Text className='esim-rating-description'>
                    Trusted by <Text strong className='esim-rating-highlight'>10,000+</Text> Travelers
                  </Text>
                </div>

                <Text className='esim-description'>
                  Our {
                  activePackageType === 3
                    ? 'Global'
                    : countryDetails.name
                } eSIM provides instant connectivity for travelers {
                  activePackageType === 3
                    ? 'worldwide'
                    : routeType === 'region'
                    ? 'across the region'
                    : 'nationwide'
                }.
                  Eliminating physical SIM swaps, we offer high-speed internet at competitive rates.
                </Text>

                {/* Feature Tags */}
                <div className='esim-features-section'>
                  <Tag className='esim-feature-tag'>
                    📱 Easy Installation
                  </Tag>
                  <Tag className='esim-feature-tag'>
                    🚫 No Roaming Fees
                  </Tag>
                  <Tag className='esim-feature-tag'>
                    💰 Money-back Guarantee
                  </Tag>
                  {activePackageType === 3 && (
                    <Tag className='esim-feature-tag'>
                      🌍 Worldwide Coverage
                    </Tag>
                  )}
                  {activePackageType === 2 && (
                    <Tag className='esim-feature-tag'>
                      🌍 Multi-Country Coverage
                    </Tag>
                  )}
                  {activePackageType === 1 && (
                    <Tag className='esim-feature-tag'>
                      🏠 Local Network Priority
                    </Tag>
                  )}
                </div>

                {/* Choose Your Plan Section */}
                <Card className='esim-plan-selection-card'>
                  <div className='esim-plan-header'>
                    <Title level={2} className='esim-plan-title'>
                      Choose your plan
                    </Title>
                    <div>
                      <div>
                        <Tag
                          className={activePackageType === 1 ? 'esim-plan-tag-active' : 'esim-plan-tag-inactive'}
                          onClick={() => handlePackageTypeChange(1)}
                          style={{ cursor: 'pointer' }}
                        >
                          Local eSIMs {packageType1 && packageType1.length > 0 && `(${packageType1.length})`}
                        </Tag>
                        <Tag
                          className={activePackageType === 2 ? 'esim-plan-tag-active' : 'esim-plan-tag-inactive'}
                          onClick={() => handlePackageTypeChange(2)}
                          style={{ cursor: 'pointer' }}
                        >
                          Regional eSIMs {packageType2 && packageType2.length > 0 && `(${packageType2.length})`}
                        </Tag>
                        <Tag
                          className={activePackageType === 3 ? 'esim-plan-tag-active' : 'esim-plan-tag-inactive'}
                          onClick={() => handlePackageTypeChange(3)}
                          style={{ cursor: 'pointer' }}
                        >
                          Global eSIMs {packageType3 && packageType3.length > 0 && `(${packageType3.length})`}
                        </Tag>
                      </div>
                    </div>
                  </div>

                  {/* Package Options */}
                  <Row gutter={[16, 16]} className='esim-packages-section'>
                    {(packageList || []).filter(pkg => pkg.product_code !== 'EE').map((pkg) => {
                      console.log(pkg, '===============ddm')
                      let displayName = countryDetails.name
                      let displayIcon = countryDetails.name.charAt(0)
                      let iconClass = 'local-icon'

                      if (activePackageType === 3) {

                        displayName = 'World'
                        displayIcon = '🌍'
                        iconClass = 'global-icon'
                      } else if (activePackageType === 2) {

                        displayName = countryDetails.name
                        displayIcon = countryDetails.name.charAt(0)
                        iconClass = 'regional-icon'
                      } else {
                        // Local packages - show country name
                        displayName = countryDetails.name
                        displayIcon = countryDetails.name.charAt(0)
                        iconClass = 'local-icon'
                      }

                      return (
                        <Col xs={24} sm={8} key={pkg.id}>
                          <Card
                            className={`esim-package-card ${
                              selectedPackage && selectedPackage.package_id === pkg.package_id
                                ? 'esim-package-card-selected'
                                : ''
                            }`}
                            bodyStyle={{ padding: '20px', textAlign: 'center' }}
                            onClick={() => setSelectedPackage(pkg)}
                          >
                            <div className={`esim-package-icon ${iconClass}`}>
                              {displayIcon}
                            </div>

                            <Title level={4} className='esim-package-country-title'>
                              {displayName}
                            </Title>

                            <Title level={3} className='esim-package-data-title'>
                              {pkg.data}GB
                            </Title>

                            <Text className='esim-package-data-label'>
                              Data Only
                            </Text>

                            <Text className='esim-package-validity'>
                              {pkg.day} Days
                            </Text>

                            {/* Bottom flex row: Quantity - Amount - Details */}
                            <div className='esim-package-controls'>
                              {/* Quantity Controls */}
                              <div className='esim-package-quantity'>
                                {/*<Icon type={'minus'}*/}
                                {/*      onClick={(e) => {*/}
                                {/*          e.stopPropagation();*/}
                                {/*          updateQuantity(pkg.id, -1);*/}
                                {/*      }}*/}
                                {/*      disabled={(quantities[pkg.id] || 1) <= 1}*/}
                                {/*      className="esim-quantity-btn"*/}
                                {/*/>*/}
                                {/*<Text strong className="esim-package-quantity-text">*/}
                                {/*    {quantities[pkg.id] || 1}*/}
                                {/*</Text>*/}
                                {/*<Icon type={'plus'}*/}
                                {/*      onClick={(e) => {*/}
                                {/*          e.stopPropagation();*/}
                                {/*          updateQuantity(pkg.id, 1);*/}
                                {/*      }}*/}
                                {/*      className="esim-quantity-btn"*/}
                                {/*/>*/}
                              </div>

                              {/* Amount */}
                              <Title level={4} className='esim-package-amount'>
                                £{pkg.amount}
                              </Title>

                              {/* Details Button */}
                              <Button
                                size='small'
                                className='esim-package-details-btn'
                                onClick={(e) => handlePackageDetailsClick(e, pkg)}
                              >
                                Details
                              </Button>
                            </div>
                          </Card>
                        </Col>
                      )
                    })}
                  </Row>

                  {packageList.length === 0 && (
                    <div style={{ textAlign: 'center', padding: '40px 0' }}>
                      <Text className='esim-plan-title'>
                        No {activePackageType === 1 ? 'local' : activePackageType === 2 ? 'regional' : 'global'} packages
                        available
                      </Text>
                    </div>
                  )}

                  {/* Buy Now Button */}
                  <Button
                    block
                    size='large'
                    type='primary'
                    disabled={!selectedPackage || !selectedPackage.package_id}
                    onClick={handleBuyNow}
                    className={`esim-buy-now-btn ${
                      selectedPackage && selectedPackage.package_id
                        ? 'esim-buy-now-btn-enabled'
                        : 'esim-buy-now-btn-disabled'
                    }`}
                  >
                    Buy your eSIM now
                  </Button>
                </Card>

                {/* Secure Payment */}
                <div className='esim-secure-payment'>
                  <Text className='esim-secure-payment-text'>
                    Secure Payment with:
                  </Text>
                  <div className='esim-payment-methods'>
                    <Text className='esim-payment-method'>VISA</Text>
                    <Text className='esim-payment-method'>Mastercard</Text>
                    <Text className='esim-payment-method'>G Pay</Text>
                    <Text className='esim-payment-method'>Apple Pay</Text>
                    <Text className='esim-payment-method'>PayPal</Text>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Card>

        {/* Plan Details Modal */}
        {showPlanDetails.visible && (
          <PlanDetailsModal
            {...showPlanDetails}
            onClose={handleModalClose}
            onSubmit={handleModalSubmit}
            packageData={showPlanDetails.packageData}
          />
        )}
      </div>
    </div>
  )
}

export default EsimPackageDetails
